const DOWNLOADABLE_EXTENSIONS = new Set(['xlsx', 'zip']);

export const isDownloadableReportExtension = (extension?: string): boolean =>
  DOWNLOADABLE_EXTENSIONS.has(extension?.toLowerCase() ?? '');

export const isValidReportDownloadUrl = (url?: string): url is string =>
  Boolean(url && (url.startsWith('http://') || url.startsWith('https://')));

export const triggerReportDownload = (
  url: string,
  reportName: string,
  extension?: string,
): void => {
  const normalizedExtension = extension?.toLowerCase();
  const fileName =
    normalizedExtension && !reportName.toLowerCase().endsWith(`.${normalizedExtension}`)
      ? `${reportName}.${normalizedExtension}`
      : reportName;

  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
